import { Routes } from '@angular/router'
import { RoutesEnum } from '@ui-core/enums/routes.enum'
import { canDeactivateGuard } from '@ui-core/guards/alert-unsaved-changes.guard'
import { AuthGuard } from '@ui-core/guards/auth.guard'

export const simulationsRoutes: Routes = [
    {
        path: `${RoutesEnum.INVENTORY_OPTIMIZATION}/${RoutesEnum.SIMULATIONS}`,
        loadComponent: () => import('./simulations').then((m) => m.Simulations),
        canActivate: [AuthGuard]
    },
    {
        path: `${RoutesEnum.INVENTORY_OPTIMIZATION}/${RoutesEnum.SIMULATION}/new`,
        loadComponent: () => import('./simulation').then((m) => m.Simulation),
        canActivate: [AuthGuard],
        canDeactivate: [canDeactivateGuard]
    },
    {
        path: `${RoutesEnum.INVENTORY_OPTIMIZATION}/${RoutesEnum.SIMULATION}/:simulationId/${RoutesEnum.JOB}/:id`,
        loadComponent: () => import('../jobs/job').then((m) => m.Job),
        canActivate: [AuthGuard],
        canDeactivate: [canDeactivateGuard]
    },
    {
        path: `${RoutesEnum.INVENTORY_OPTIMIZATION}/${RoutesEnum.SIMULATION}/:id`,
        loadComponent: () => import('./simulation').then((m) => m.Simulation),
        canActivate: [AuthGuard],
        canDeactivate: [canDeactivateGuard]
    }
]
